<template>
  <b-modal
    :id="modalId"
    :title="title"
    @hidden="reset"
    hide-footer
    no-close-on-backdrop
  >
    <b-tabs content-class="mt-3" v-if="selectedVersion">
      <b-tab title="New Download">
        <div v-if="newDownloadSuccess" class="alert alert-success" role="alert">
          Success! New download has been created.
        </div>
        <download-form
          :version="selectedVersion"
          @hasUpdate="newDownload"
          @clearSuccess="newDownloadSuccess = false"
        />
      </b-tab>
      <b-tab title="Edit Version">
        <version-form
          :version="selectedVersion"
          @hasUpdate="$emit('hasUpdate')"
        />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import VersionForm from "../Forms/VersionForm";
import DownloadForm from "../Forms/DownloadForm";
import config from "../../constants/config";
import { mapGetters } from "vuex";

export default {
  name: "VersionModal",
  components: {
    VersionForm,
    DownloadForm
  },
  data() {
    return {
      newDownloadSuccess: false
    };
  },
  methods: {
    newDownload() {
      this.newDownloadSuccess = true;
      this.$emit("hasUpdate");
    },
    reset() {
      this.newDownloadSuccess = false;
    }
  },
  computed: {
    ...mapGetters("product", ["selectedVersion"]),
    modalId() {
      return config.VERSION_MODAL_ID;
    },
    title() {
      return `Version ${
        this.selectedVersion ? this.selectedVersion.version : ""
      }`;
    }
  }
};
</script>
